import { render } from "./ItemList.vue?vue&type=template&id=29b96fee&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=29b96fee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29b96fee"

export default script